import React from 'react';
import { Loader2 } from 'lucide-react';
const DEFAULT_CHECKOUT_URL = 'https://argrutinas.com/cart/42979413688529:1';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  href?: string;
  checkoutValue?: number;
  onBeforeNavigate?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  href,
  checkoutValue = 8900,
  onBeforeNavigate,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm',
    secondary: 'bg-blue-100 text-blue-900 hover:bg-blue-200',
    outline: 'border border-slate-200 bg-white hover:bg-slate-100 text-slate-900',
    ghost: 'hover:bg-slate-100 text-slate-700'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-10 px-4 py-2',
    lg: 'h-12 px-8 text-lg',
    xl: 'h-14 px-10 text-xl font-bold'
  };
  const checkoutUrl = href || DEFAULT_CHECKOUT_URL;
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={e => {
    // Allow parent to intercept and prevent navigation
    if (onBeforeNavigate) {
      onBeforeNavigate(e);
      // If parent called preventDefault, stop here
      if (e.defaultPrevented) return;
    }
    // Fire Meta Pixel
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Kit de Emergencia SOS Ansiedad',
        content_ids: ['42979413688529'],
        content_type: 'product',
        value: checkoutValue,
        currency: 'ARS'
      });
    }
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className} ${disabled || isLoading ? 'pointer-events-none opacity-50' : ''}`} data-id="element-379">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-380" />}
      {children}
    </a>;
}